import React from 'react'
import { useQuery } from 'react-query'
import { useRouter } from 'next/router'
import FnOCallPut from './FnoCallPut'
import FnOListingWidget from '@/components/Stocks/FnO/ListingWidget'
import { getFetchRequest } from '@/root/utils/network-adapter/fetch-request'
import { indianStocksPrivateApiBaseUrl } from '@/root/api/apiConstants'
import { ICategoryFnO } from '@/components/Stocks/FnO/types/options-chain'
import { FUTURES } from '@/components/Stocks/FnO/constants'
import InStockL2Heading from '@/components/Stocks/Pages/InStockDetailPageV2/InL2Heading'

const FnO = ({
  isStocks = false,
  short_name,
}: {
  isStocks?: boolean
  short_name?: string
}) => {
  const router = useRouter()
  const slug = router.query.stockSlug as string

  const {
    data,
  }: {
    data?: ICategoryFnO
  } = useQuery(
    ['fnoCategories', slug],
    () =>
      getFetchRequest({
        url: `${indianStocksPrivateApiBaseUrl}/fno/catalog/categories/${slug}`,
      }),
    {
      retry: 1,
    },
  )

  const categoryData =
    data?.catalog?.stock_details ?? data?.catalog?.index_details

  const futures = categoryData?.categories?.find(item =>
    item.category_code.toUpperCase().includes(FUTURES),
  )

  return (
    <div>
      <InStockL2Heading
        heading="Futures and Options"
        subheading={`View the latest movement in ${short_name} Futures & Options, including strike prices, expiry dates, and percentage changes.
`}
      />
      <div className="flex flex-col gap-y-11">
        {categoryData && (
          <FnOCallPut
            isStocks={isStocks}
            short_name={short_name}
            categoryData={categoryData}
          />
        )}

        {!!futures?.stocks?.length && (
          <FnOListingWidget
            categoryData={futures.stocks}
            heading={isStocks ? `${short_name} Futures` : 'Futures'}
          />
        )}
      </div>
    </div>
  )
}

export default React.memo(FnO)
